import blog1 from "../../assets/images/blog/img-1.jpg"
import blog2 from "../../assets/images/blog/img-2.jpg"
import blog3 from "../../assets/images/blog/img-3.jpg"
import blog4 from "../../assets/images/blog/img-4.jpg"
import blog5 from "../../assets/images/blog/img-5.jpg"
import blog6 from "../../assets/images/blog/img-6.jpg"

const listData = [
    {
        "image": blog1,
        "category": "Modern aesthetics",
        "title": "The Evolution of Minimalism in Design",
        "date": "05 Apr, 2024",
        "views": 451,
        "description": "Minimalism is more than just a trend; it's a movement that continues to influence design worldwide. Learn how simplicity in design evolved and why it remains impactful today.",
        "read_more_link": "pages-blog-overview.html",
        "tags": ["#MinimalDesign", "#Simplicity", "#DesignTrends"]
    },
    {
        "image": blog2,
        "category": "Creating seamless journeys",
        "title": "Mastering User Experience Through Storytelling",
        "date": "11 Feb, 2024",
        "views": 713,
        "description": "Storytelling transforms user experiences by providing intuitive and engaging journeys. Discover how to integrate compelling narratives into UX design for maximum impact.",
        "read_more_link": "pages-blog-overview.html",
        "tags": ["#UXDesign", "#Storytelling"]
    },
    {
        "image": blog3,
        "category": "Infusing intention",
        "title": "Designing for Purpose: A Mindful Approach",
        "date": "09 July, 2024",
        "views": 479,
        "description": "In a world driven by trends, designing with purpose is key to creating meaningful work. Explore techniques to craft with intention and make every design count.",
        "read_more_link": "pages-blog-overview.html",
        "tags": ["#MindfulDesign", "#IntentionalLiving", "#PurposefulWork"]
    },
    {
        "image": blog4,
        "category": "Boosting productivity",
        "title": "Creative Workflow Hacks for Designers",
        "date": "15 Sep, 2024",
        "views": 174,
        "description": "Juggling creativity with deadlines can be a challenge. This post covers essential workflow tips and tools to keep your design process efficient and inspired.",
        "read_more_link": "pages-blog-overview.html",
        "tags": ["#CreativeProcess", "#ProductivityTips", "#DesignerLife"]
    },
    {
        "image": blog6,
        "category": "Practical strategies",
        "title": "How to Overcome Creative Block",
        "date": "24 Oct, 2024",
        "views": 1926,
        "description": "Every designer faces creative block at some point. Learn actionable strategies to break through these moments and find inspiration to fuel your next project.",
        "read_more_link": "pages-blog-overview.html",
        "tags": ["#CreativeBlock", "#DesignMotivation", "#CreativityUnleashed"]
    },
    {
        "image": blog4,
        "category": "Crafting a visual story",
        "title": "Building Brand Identity through Design",
        "date": "20 Sept, 2024",
        "views": 1337,
        "description": "A strong brand identity is built on thoughtful design. Learn how to create cohesive visual stories that reflect your brand's values and connect with your audience.",
        "read_more_link": "pages-blog-overview.html",
        "tags": ["#BrandDesign", "#IdentityCreation"]
    }
]

const gridData = [
    {
        "title": "The Mindful Journal",
        "image": blog1,
        "description": "Exploring the beauty of slow living and intentional growth. Discover tips on mindfulness, wellness, and living a balanced life.",
    },
    {
        "title": "Next Gen Creators",
        "image": blog2,
        "description": "Empowering the creators A platform for sharing creative projects, tech solutions, and future-thinking ideas to shape the next generation.",
    },
    {
        "title": "The Thought Canvas",
        "image": blog3,
        "description": "Where ideas come to life through words and design. Exploring the intersection of creativity, technology, and thoughtful living to fuel your next big idea.",
    },
    {
        "title": "The Insight Collective",
        "image": blog4,
        "description": "Curated perspectives on creativity, innovation, and lifestyle. A blend of expert insights, stories, and tips to inspire personal growth and creative thinking.",
    },
    {
        "title": "Life by Design",
        "image": blog5,
        "description": "Crafting a life full of intention Explore ideas on mindful living, personal development, and how to design a life that truly inspires you.",
    },
    {
        "title": "Crafted Perspectives",
        "image": blog6,
        "description": "Where thoughtful design meets meaningful storytelling. Sharing unique viewpoints on creativity, innovation, and the art of crafting a fulfilling life.",
    },
    {
        "title": "Beyond the Blueprint",
        "image": blog4,
        "description": "Designing a life of creativity A space for creators, dreamers, and innovators to explore ideas and strategies for building a meaningful life.",
    },
    {
        "title": "The Imagination Engine",
        "image": blog4,
        "description": "A hub for artists, tech enthusiasts, and creatives looking to stay ahead of the curve and bring ideas to life ideas, trends, and inspiration.",
    }
]

export { listData, gridData }